import { useState } from "react";

/* Type an email, press Enter (or comma) and it becomes a tag. Used for Cc and
   Bcc on the composer, so several people can be copied without a free-text
   mess. Invalid addresses are refused here rather than on send. */
const VALID = /^[^@\s,;]+@[^@\s,;]+\.[^@\s,;]{2,}$/;

export const RecipientTags = ({ label, value = [], onChange, testid, suggestions = [] }) => {
  const [draft, setDraft] = useState("");
  const [error, setError] = useState("");

  const add = (raw) => {
    const parts = String(raw).split(/[,;]/).map((s) => s.trim()).filter(Boolean);
    if (!parts.length) return true;
    const bad = parts.find((p) => !VALID.test(p));
    if (bad) { setError(`"${bad}" doesn't look like an email`); return false; }
    const next = [...value];
    parts.forEach((p) => {
      if (!next.some((x) => x.toLowerCase() === p.toLowerCase())) next.push(p);
    });
    onChange(next);
    setError(""); setDraft("");
    return true;
  };

  const remove = (email) => onChange(value.filter((v) => v !== email));

  const unused = suggestions.filter(
    (s) => s && !value.some((v) => v.toLowerCase() === s.toLowerCase()));

  return (
    <div data-testid={testid}>
      <label className="text-xs text-[#59554D]">{label}</label>
      <div className="flex flex-wrap items-center gap-1.5 mt-1 min-h-[38px] rounded-[8px] px-2 py-1.5 bg-[#F4F2ED] border border-[#DAD5CA]">
        {value.map((email) => (
          <span key={email} data-testid={`${testid}-tag-${email}`}
            className="inline-flex items-center gap-1.5 pl-2 pr-1 py-0.5 rounded-full text-[12.5px] bg-white border border-[#DAD5CA] text-[#1A1A1A]">
            {email}
            <button type="button" onClick={() => remove(email)} aria-label={`Remove ${email}`}
              data-testid={`${testid}-remove-${email}`}
              className="w-4 h-4 rounded-full flex items-center justify-center text-[#8A857A] hover:text-[#1A1A1A] hover:bg-[#F0EDE6]">
              ×
            </button>
          </span>
        ))}
        <input value={draft} onChange={(e) => { setDraft(e.target.value); setError(""); }}
          data-testid={`${testid}-input`}
          placeholder={value.length ? "Add another…" : "name@company.com"}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === "," || e.key === ";") { e.preventDefault(); add(draft); }
            else if (e.key === "Backspace" && !draft && value.length) remove(value[value.length - 1]);
          }}
          onBlur={() => add(draft)}
          className="flex-1 min-w-[150px] bg-transparent text-[13px] text-[#1A1A1A] outline-none px-1 py-0.5" />
      </div>
      {error && <div className="text-[11.5px] mt-1 text-[#8E1212]" data-testid={`${testid}-error`}>{error}</div>}
      {unused.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-1.5">
          {unused.slice(0, 4).map((s) => (
            <button key={s} type="button" onClick={() => add(s)} data-testid={`${testid}-suggest-${s}`}
              className="text-[11.5px] px-2 py-0.5 rounded-full border border-[#E6E2D9] text-[#59554D] hover:bg-[#F6F4EF]">
              + {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecipientTags;
